import styled from 'styled-components';

export const Bottom = styled.section`
  width: 100%;
  padding: 28px;

  > div {
    flex-direction: row;
    justify-content: space-between;
  }

  .copy {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;

    svg {
      width: 16px;
      margin-bottom: 4px;
      color: ${({ theme }) => theme.colors.grey.white};
    }

    @media ${({ theme }) => theme.devices.mobile} {
      span {
        font-size: 12px;
      }
    }
  }

  @media ${({ theme }) => theme.devices.tablet} {
    > div {
      flex-direction: column;
    }
  }
`;
